import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Compact top bar with the drawer trigger. Shown below 1200px (where the sidebar
 * is an off-canvas drawer) and hidden once the sidebar docks — see the
 * "RESPONSIVE SHELL" block in public/css/goldhub-theme.css.
 *
 * props:
 * - onToggleNav: open/close the drawer
 * - navOpen: current drawer state (for aria-expanded / icon)
 */
function NavBar(props) {
    return (
        <nav className="navbar navbar-dark gh-topbar px-3 col-12">
            <Link className="navbar-brand d-flex align-items-center gap-2 m-0" to="/dashboard">
                <img src="/img/favicon/favicon-32x32.png" height="26" width="26" alt="GoldHub" />
                <span className="fw-bold">GoldHub</span>
            </Link>
            <button
                className="gh-nav-toggler"
                type="button"
                onClick={props.onToggleNav}
                aria-controls="sidebarMenu"
                aria-expanded={props.navOpen ? 'true' : 'false'}
                aria-label="Toggle navigation"
            >
                <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    {props.navOpen
                        ? <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        : <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />}
                </svg>
            </button>
        </nav>
    );
}

export default NavBar;
